<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <br>
    <div class="update-password">
      <h2>Actualizar Clave</h2>
      <form @submit.prevent="updatePassword">
        <div>
          <label for="newPassword">Clave Actual:</label>
          <input type="password" id="currentPassword" v-model="currentPassword" required>
        </div>
        <div>
          <label for="newPassword">Nueva Clave:</label>
          <input type="password" id="newPassword" v-model="newPassword" required>
        </div>
        <div>
          <label for="confirmPassword">Confirmar Nueva Clave:</label>
          <input type="password" id="confirmPassword" v-model="confirmPassword" required>
        </div>
        <button type="submit">Actualizar Clave</button>
        <p v-if="message">{{ message }}</p>
      </form>
    </div>
    <Footer />

  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'

import api from "@/services/api";

export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      message: ''
    };
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    updatePassword() {
      if (!this.currentPassword) {
        this.message = 'Ingrese la contraseña actual';
        return;
      }
      if (!this.newPassword) {
        this.message = 'Ingrese la nueva contraseña';
        return;
      }
      if (!this.confirmPassword) {
        this.message = 'Ingrese la confirmación de la contraseña';
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.message = 'Las contraseñas no coinciden';
        return;
      }
      const userId = 105; // Ejemplo de ID de usuario
      const data = {
        claveActual: this.currentPassword,
        nuevaClave: this.newPassword
      };
      api.post(`/actualizar-clave/${userId}`, data)
        .then(response => {
          this.message = response.data;
          this.newPassword = ''; // Limpiar el campo después de la actualización
          this.confirmPassword = '';
        })
        .catch(error => {
          this.message = 'Error al actualizar la clave: ' + error.response.data;
        });
    }
  }
}
</script>

<style scoped>
.update-password {
  max-width: 300px;
  margin: auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.update-password label {
  font-weight: bold;
}

.update-password input {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  margin-bottom: 20px;
}

.update-password button {
  width: 100%;
  padding: 10px;
  background-color: #42b983;
  color: white;
  border: none;
  cursor: pointer;
}

.update-password button:hover {
  background-color: #36976b;
}

.update-password p {
  color: red;
}
</style>
